import { CustomEventName, GTMEventKey } from '@/utils/gtm';
import { GTMButton } from '@/components/atoms/GTMButton';
import { QuotesCodeMapping } from '@/constants/quote/quote';
import CountriesIcons from '@/components/atoms/CountriesIcons/CountriesIcons';
import classNames from 'classnames';
import Link from 'next/link';
const FOREX_REDIRECT_PAGE_LINK = '/order';

type Quotes = {
  [QuotesCodeMapping.SYMBOL]: string;
  [QuotesCodeMapping.CHINESE_NAME]: string;
  [QuotesCodeMapping.ENGLISH_NAME]: string;
  [QuotesCodeMapping.CLOSE]: string;
  [QuotesCodeMapping.CHANGE_V2]: string;
  [QuotesCodeMapping.CHANGE_PERCENT_V2]: string;
};

type CarosuelItemProps = {
  data: Quotes;
};

const CarosuelItem = ({ data }: CarosuelItemProps) => {
  const name = data[QuotesCodeMapping.CHINESE_NAME];
  const englishName = data[QuotesCodeMapping.ENGLISH_NAME];
  const price = data[QuotesCodeMapping.CLOSE];
  const percent = data[QuotesCodeMapping.CHANGE_PERCENT_V2] || '';
  const isRise = percent?.includes('+');
  const isFall = percent?.includes('-');
  const symbol = data[QuotesCodeMapping.SYMBOL];
  const gtmEvent = {
    [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_AD,
    [GTMEventKey.SECTION]: '%p_申購',
    [GTMEventKey.CLICK_ITEM]: `${symbol}_${name}`
  };

  return (
    <GTMButton gtmEvent={gtmEvent} style='w-full'>
      <Link
        href={FOREX_REDIRECT_PAGE_LINK}
        className='flex h-10 w-full items-center gap-4 rounded-lg bg-[#383838] px-2 py-[5px] text-sm text-white'
      >
        <div className='flex flex-1'>
          {englishName?.includes('/') && <CountriesIcons countries={englishName.split('/')} />}
          <div className='ml-[6px] flex flex-col'>
            <p className='mb-1 text-nowrap text-left font-semibold leading-[14px]'>{name}</p>
            <p className='text-sx text-nowrap text-left leading-3 text-[#ffffffa8]'>{englishName}</p>
          </div>
        </div>
        <div className='flex w-20 flex-col text-right'>
          <p className='mb-1 font-bold leading-[14px]'>{price}</p>
          <p className='text-sx leading-3 text-[#ffffffa8]'>價格</p>
        </div>
        <div className='flex w-20 flex-col text-right'>
          <p
            className={classNames('mb-1 font-bold leading-[14px]', {
              'text-[#e03f19]': isRise,
              'text-[#2bad09]': isFall
            })}
          >
            {percent}%
          </p>
          <p className='text-sx text-nowrap leading-3 text-[#ffffffa8]'>單日走勢</p>
        </div>
        <div className='w-16 text-right'>
          <span className='rounded-md bg-[#e03f19] px-2 py-1'>開戶</span>
        </div>
      </Link>
    </GTMButton>
  );
};

export default CarosuelItem;
